import { IOrganisationIndexCategory } from "../../model/OrganisationIndexCategory";

export interface TOrganisationIndexCategoryPresentationModel
  extends IOrganisationIndexCategory {
  nameTranslation: string;
}

const OrganisationIndexCategoryPresentationModel = (
  data: IOrganisationIndexCategory,
  nameTranslation?: string
) => {
  const handler: ProxyHandler<IOrganisationIndexCategory> = {
    get: function (target, prop, receiver) {
      switch (prop) {
        case "nameTranslation":
          return nameTranslation;
        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<
    IOrganisationIndexCategory,
    TOrganisationIndexCategoryPresentationModel
  >(data, handler);
};

export default OrganisationIndexCategoryPresentationModel;
